// ── Transaction Types ──────────────────────────────────────────────
export const TRANSACTION_TYPES = [
  { value: 'credit', label: 'Credit' },
  { value: 'debit', label: 'Debit' },
  { value: 'hold', label: 'Hold' },
  { value: 'release', label: 'Release' },
  { value: 'transfer_in', label: 'Transfer In' },
  { value: 'transfer_out', label: 'Transfer Out' },
  { value: 'refund', label: 'Refund' },
];

export const TRANSACTION_TYPE_MAP = Object.fromEntries(
  TRANSACTION_TYPES.map((t) => [t.value, t.label])
);

// ── Wallet Types ───────────────────────────────────────────────────
export const WALLET_TYPES = [
  { value: 'real_money', label: 'Real Money' },
  { value: 'reward', label: 'Reward' },
];

// ── Payout Methods ─────────────────────────────────────────────────
export const PAYOUT_METHODS = [
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'check', label: 'Check' },
  { value: 'cash', label: 'Cash' },
  { value: 'financial_aid_reversal', label: 'Financial Aid Reversal' },
  { value: 'other', label: 'Other' },
];

// ── Payout Statuses ────────────────────────────────────────────────
export const PAYOUT_STATUSES = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'processed', label: 'Processed' },
  { value: 'failed', label: 'Failed' },
  { value: 'cancelled', label: 'Cancelled' },
];

// ── Closeout / Payout Reasons ──────────────────────────────────────
export const PAYOUT_REASONS = [
  { value: 'closeout', label: 'Closeout' },
  { value: 'withdrawal', label: 'Withdrawal' },
  { value: 'graduation', label: 'Graduation' },
  { value: 'termination', label: 'Termination' },
  { value: 'other', label: 'Other' },
];

// ── Settlement Statuses ────────────────────────────────────────────
export const SETTLEMENT_STATUSES = [
  { value: 'pending', label: 'Pending' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'disputed', label: 'Disputed' },
];

// ── Revenue Report Group By ────────────────────────────────────────
export const GROUP_BY_OPTIONS = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
];

// ── Hold Statuses ──────────────────────────────────────────────────
export const HOLD_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'captured', label: 'Captured' },
  { value: 'released', label: 'Released' },
  { value: 'expired', label: 'Expired' },
];

// ── Status Badge Color Mapping ─────────────────────────────────────
export const STATUS_COLORS = {
  // transaction types
  credit: 'success',
  debit: 'danger',
  hold: 'warning',
  release: 'info',
  transfer_in: 'success',
  transfer_out: 'danger',
  refund: 'primary',
  // wallet types
  real_money: 'primary',
  reward: 'warning',
  // payout statuses
  pending: 'warning',
  approved: 'info',
  processed: 'success',
  failed: 'danger',
  cancelled: 'secondary',
  // settlement statuses
  confirmed: 'success',
  disputed: 'danger',
  // hold statuses
  active: 'success',
  captured: 'info',
  released: 'secondary',
  expired: 'danger',
  // generic
  true: 'success',
  false: 'danger',
};

// ── Default Pagination ─────────────────────────────────────────────
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
